import React from 'react';
import { Star } from 'lucide-react';

export const AIScoreDisplay = ({ score, size = 'md' }) => {
  const getScoreColor = (s) => {
    if (s >= 80) return 'text-emerald-500';
    if (s >= 60) return 'text-blue-500';
    if (s >= 40) return 'text-amber-500';
    return 'text-red-500';
  };
  
  const getScoreBg = (s) => {
    if (s >= 80) return 'bg-emerald-50';
    if (s >= 60) return 'bg-blue-50';
    if (s >= 40) return 'bg-amber-50';
    return 'bg-red-50';
  };
  
  const stars = Math.round(score / 20);
  
  if (size === 'sm') {
    return (
      <div className={`flex items-center gap-1 px-2 py-0.5 rounded-full ${getScoreBg(score)}`}>
        <Star className={`h-3 w-3 fill-current ${getScoreColor(score)}`} />
        <span className={`text-xs font-bold ${getScoreColor(score)}`}>{score}</span>
      </div>
    );
  }
  
  return (
    <div className={`flex flex-col items-center p-3 rounded-lg ${getScoreBg(score)}`}>
      <div className="flex gap-0.5 mb-1">
        {[...Array(5)].map((_, i) => (
          <Star 
            key={i} 
            className={`h-4 w-4 ${i < stars ? `fill-current ${getScoreColor(score)}` : 'text-gray-300'}`}
          />
        ))}
      </div>
      <span className={`text-2xl font-bold ${getScoreColor(score)}`}>{score}</span>
      <span className="text-xs text-muted-foreground">AI Score</span>
    </div>
  );
};
